<!-- rendering from templates -->
<div
  [ngClass]="{ 'panel-content1': mapLevel !== 500 }"
  class="panel-content"
  [innerHtml]="html | sanitizeHtml"
></div>
<!-- rendering from templates end -->

<div class="panel-content demiPanel" *ngIf="mapLevel === 500">
  <div class="share-mode share-mode1">
    <p class="m-inline" id="text-bold">Require Checkbox</p>
    <input
      type="checkbox"
      name="requireCheckbox"
      #saveUserNameCheckBox
      id="saveUserNameCheckBox"
      [(ngModel)]="requireCheckbox"
      (change)="onSaveUsernameChanged(saveUserNameCheckBox.checked)"
    />
  </div>
  <div class="share-mode">
    <p class="m-inline" id="text-bold">Choose Privilege Level:</p>
    <select
      id="basicData"
      (change)="layerSelect($event)"
      [(ngModel)]="selectedUser"
    >
      <option
      value="{{ data.privilegeLevel }}"
        *ngFor="let data of accessLevel"
      >
        {{ data.access }}
      </option>
    </select>
  </div>
  <div class="share-mode share-mode3">
    <p class="m-inline" id="text-bold">Choose Link Duration</p>
  </div>
  <div class="share-time" *ngFor="let day of days">
    <p class="m-inline">{{ day }}</p>
    <input
      [checked]="day === selectedDay"
      class="pull-right inline m-inline"
      type="radio"
      name="time"
      value="{{ day }}"
      (change)="selectDay($event)"
    />
  </div>
  <div class="button-container">
    <a
      (click)="createLink()"
      id="generate-live-share"
      class="btn btn-default pull-right"
      title="Makes a hyperlink that opens to your current map view."
      >Create Link</a
    >
    <div style="clear: both"></div>
  </div>
</div>
<div
  class="panel-content"
  *ngIf="mapLevel !== 500"
  [ngClass]="{ 'panel-content1': mapLevel !== 500 }"
>
  <div class="button-container" *ngIf="!show">
    <a
      (click)="createLink()"
      id="generate-live-share"
      class="btn btn-default pull-right"
      title="Makes a hyperlink that opens to your current map view."
      >Create Link</a
    >
    <div style="clear: both"></div>
  </div>
</div>
<div id="share-view-2" *ngIf="show">
  <p class="panel-text">Copy link and send via email, text and so on.</p>
  <div id="share-url-area">
    <input
      class="m-inline"
      type="text"
      id="share-url"
      value="{{ shereLinkData }}"
      #inputElement
      readonly
    /><a
      id="copy-to-clipboard"
      class="btn-primary m-inline"
      data-copytarget="#share-url"
      title="Copies hyperlink to clipboard automatically."
      (click)="clipboard(inputElement)"
      >Copy</a
    >
  </div>
  <div class="button-container">
    <a
      id="reset-share-link"
      class="btn btn-default pull-right"
      title="Create a new link"
      (click)="reset()"
      >Start Over</a
    >
    <div style="clear: both"></div>
  </div>
</div>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img
      (click)="closeLeft()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span
      class="tooltiptext tip-bottom"
      [innerHtml]="mapService.templatetoolTips['close_left_panel']"
    ></span>
  </a>
</div>
<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <p class="loading" > <img src="/assets/img/wheel.svg" alt="Girl in a jacket" width="100px" height="100px" > </p>
  </ngx-spinner>
